const accessibilityProps = {
  useAutoplayToggleButton: false,
  useGroupRole: true,
  instructionsText: null,
  regionLabel: 'carousel',
  focusOnSelect: false,
}

export default accessibilityProps
